import type { Icon } from '../../../amplienceTypes/schemas/exported/usp-item-schema';
import type { ColorScheme } from '../../../amplienceTypes/schemas/exported/usp-list-schema';
import type { ReactElement } from 'react';

import styled, { css } from 'styled-components';

import { colors } from '../core/styles';

const getUSPItemIcon = (icon: Icon) => {
  const uspItemIcons: { [k in Icon]: string } = {
    'Checkbox (default)': '\\f13c',
    Delivery: '\\f1bd',
    Ordering: '\\f1bf',
    Payment: '\\f1c0',
    'Bike Courier': '\\f145',
    'Shopping Cart': '\\f13b',
    'Shopping Bag': '\\f245',
    'Redeem Voucher': '\\f183',
    'G-RAW Logo': '\\f152',
    'No Icon': '',
  };

  return uspItemIcons[icon];
};

const S = {
  ItemIcon: styled.span<{ $iconName: Icon; $colorScheme: ColorScheme }>`
    ${({ theme, $iconName, $colorScheme }) => css`
      color: ${$colorScheme === 'Black Friday' || $colorScheme === 'Dark' || $colorScheme === 'PPE'
        ? colors.WHITE
        : theme.colors.content.primary};
      line-height: 16px;
      margin-top: -3px;

      &::before {
        font-family: gstar-icons;
        font-size: ${theme.font.size[4]};
        margin-right: 0.2em;
        text-align: center;
        vertical-align: text-top;
        margin-left: 0.2em;
        content: '${getUSPItemIcon($iconName)}';
      }
    `}
  `,

  ItemTitle: styled.strong<{ $colorScheme: ColorScheme }>`
    ${({ theme, $colorScheme }) => css`
      font-weight: 400;
      padding: 0 0.2rem;
      color: ${() => {
        switch ($colorScheme) {
          case 'Black Friday':
          case 'PPE':
            return colors.WHITE;
          case 'Dark':
            return colors.WHITE_SMOKE_GREY;
          default:
            return theme.colors.content.primary;
        }
      }};

      & > span {
        color: ${$colorScheme === 'PPE' ? `${colors.WHITE} !important` : colors.PURE_RED};
      }
    `}
  `,
};

export interface USPItemProps {
  iconName?: Icon;
  title?: string;
  description?: string;
  colorScheme: ColorScheme;
}

export const USPItem = ({
  iconName,
  title,
  description,
  colorScheme,
}: USPItemProps): ReactElement => (
  <>
    {iconName && <S.ItemIcon $iconName={iconName} $colorScheme={colorScheme} />}
    <S.ItemTitle dangerouslySetInnerHTML={{ __html: title ?? '' }} $colorScheme={colorScheme} />
    <span>{description}</span>
  </>
);
